var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeCoreIQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "393 0 629.69921875 203.6015625",
    style: {
      enableBackground: "new 0 0 1022.7 203.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs411"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style384"
  }, "\t.st0{fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g394"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393,103.1c0-35,27.8-63.3,62.8-63.3c19,0,35.5,8.1,46.4,21l-11.8,10c-8.2-9.7-20.8-16-34.6-16    c-26,0-46.4,21.7-46.4,48.2c0,26.4,20.4,48.2,46.4,48.2c13.8,0,26.4-6.3,34.6-16l11.8,10c-10.9,12.9-27.4,21-46.4,21    C420.8,166.4,393,138.1,393,103.1z",
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.1,122.5c0-26.5,19.9-43.4,43.8-43.4c23.8,0,43.9,16.9,43.9,43.4s-20.1,43.9-43.9,43.9    C526,166.4,506.1,149,506.1,122.5z M578.2,122.5c0-17.2-12.9-28.7-28.3-28.7c-15.2,0-28,11.5-28,28.7c0,17.4,12.7,29.2,28,29.2    C565.3,151.7,578.2,139.9,578.2,122.5z",
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M660.3,82.3L657.8,97c-4.5-2.2-9-2.9-12.2-2.9c-16.7,0-23.3,17.8-23.3,39.8v30.7h-15.8V80.9h15.8v19    c4.3-14.7,12.4-20.8,23.5-20.8C651.7,79.1,657.8,80.7,660.3,82.3z",
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M743,129.5h-68.1c2.3,14.9,13.1,22.2,27.4,22.2c10.2,0,19.7-4.3,24.4-12.7l13.6,5.4    c-7.4,14.5-22.4,22.1-38.6,22.1c-23.8,0-43-17.4-43-43.9s19.2-43.4,43-43.4s41.6,16.9,41.6,43.4    C743.3,124.8,743.1,127.1,743,129.5z M727.7,116c-2-14.3-12.2-22.2-26-22.2c-14.2,0-24.2,7.2-26.7,22.2H727.7z",
    id: "path392"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 780.6,
    y: 108.1,
    className: "st0",
    width: 12.8,
    height: 15.9,
    id: "rect396"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1022.7,0v203.6H798.1V124h13.8v-15.9h-13.8V0H1022.7z M927.1,30.7c-36,0-66.5,26.1-66.5,66.6   c0,40.3,30.4,66.4,66.5,66.4c11.9,0,23.4-2.9,33.1-8.3l15.7,17.3l18.7-15.9l-15.7-17.1c9-11,14.4-25.4,14.4-42.5   C993.3,56.8,962.9,30.7,927.1,30.7 M927.1,135.7c-17.8,0-36.9-11.9-36.9-38.5c0-26.7,19.1-38.7,36.9-38.7   c17.7,0,36.7,12.1,36.7,38.7c0,8.3-1.8,14.9-4.9,20.5l-18.7-20.5L921.3,113l18.7,20.5C935.7,134.9,931.4,135.7,927.1,135.7    M850.3,72.3h-23.5v23.5h23.5V72.3z M826.7,159.7h23.5v-52.1h-23.5V159.7z",
    id: "path398"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g404"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeCoreIQ);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_Core_iQ.613856e23de4622b73f50e4164cf0b68.svg";
export { ForwardRef as ReactComponent };